// Settings host location in the URL: drill-in nav + search query. Refresh and
// share restore the same screen. Keys are the last path segment (`organisation`).

export const SETTINGS_NAV_QUERY_PARAM = 'nav';
export const SETTINGS_SEARCH_QUERY_PARAM = 'q';

export function settingsNavQueryValue(path: string): string {

  const segment = path.split('.').pop();
  return segment && segment.length > 0 ? segment : path;
}

export function settingsNavPathFromQuery(paths: readonly string[], query: string | null | undefined): string | null {

  const key = query?.trim();
  if (!key) return null;
  return paths.find(path => settingsNavQueryValue(path) === key) ?? null;
}
